import React, { useCallback, useMemo } from "react";
import { StyledContentTypeFlag } from "./content-type.styled";

import { IconPhotoType, IconVideoType, IconAudioType, IconPeopleType, IconContents } from "@mzc-cloudplex/icons";
import { CONTENT_TYPE } from "@constants";

const ContentTypeFlag = ({ type, size }) => {
    const getBackgroundColor = useCallback((type) => {
        switch (type) {
            case CONTENT_TYPE.VIDEO:
            case CONTENT_TYPE.CUSTOM:
                return "#405fff";
            case CONTENT_TYPE.PHOTO:
                return "#e86894";
            case CONTENT_TYPE.MUSIC:
                return "#e9739b";
            case CONTENT_TYPE.PEOPLE:
                return "#5f62e5";
            default:
                return "";
        }
    }, []);

    const styleBySize = useMemo(() => {
        switch (size) {
            case "small":
                return { width: "20px", height: "16px", iconSize: "12px" };
            case "medium":
            default:
                return { width: "24px", height: "20px", iconSize: "16px" };
        }
    }, [size]);

    return (
        <StyledContentTypeFlag
            sx={{
                color: `#fff`,
                backgroundColor: getBackgroundColor(type),
                width: styleBySize.width,
                height: styleBySize.height,
            }}
        >
            {type === CONTENT_TYPE.VIDEO && <IconVideoType size={styleBySize.iconSize}/>}
            {type === CONTENT_TYPE.MUSIC && <IconAudioType size={styleBySize.iconSize}/>}
            {type === CONTENT_TYPE.PHOTO && <IconPhotoType size={styleBySize.iconSize}/>}
            {type === CONTENT_TYPE.PEOPLE && <IconPeopleType size={styleBySize.iconSize}/>}
            {type === CONTENT_TYPE.CUSTOM && <IconContents size={styleBySize.iconSize}/>}
        </StyledContentTypeFlag>
    );
};

export default ContentTypeFlag;
